import ContactEmailIcon from './../../assets/images/contact_email.svg'
import ContactPhoneIcon from './../../assets/images/contact_phone.svg'

const FooterContact = () => {
    return (
        <div className="mt-6 flex flex-wrap items-center justify-end gap-12">
            <a
                href="tel:13701"
                className="flex items-center gap-3 text-gray transition-opacity hover:opacity-80"
            >
                <img
                    src={ContactPhoneIcon}
                    alt="Phone"
                    className="h-6 w-6 object-contain"
                />

                <div>
                    <p className="text-xs text-black opacity-80">Call us</p>
                    <p className="font-semibold">13701</p>
                </div>
            </a>

            <a
                href="mailto:lifestyle@sharetrip.net"
                className="flex items-center gap-3 text-gray transition-opacity hover:opacity-80"
            >
                <img
                    src={ContactEmailIcon}
                    alt="Email"
                    className="h-6 w-6 object-contain"
                />

                <div>
                    <p className="text-xs text-black opacity-80">Email us</p>
                    <p className="font-semibold">lifestyle@sharetrip.net</p>
                </div>
            </a>
        </div>
    );
}

export default FooterContact;